export default {
  "content": "<path d=\"M3.5 19h4v2h-5l-.103-.005A1 1 0 011.5 20v-5h2v4zM22.5 20a1 1 0 01-1 1h-5v-2h4v-4h2v5zM16.707 8.707L13.414 12l3.293 3.293-1.414 1.414L12 13.414l-3.293 3.293-1.414-1.414L10.586 12 7.293 8.707l1.414-1.414L12 10.586l3.293-3.293 1.414 1.414zM7.5 5h-4v4h-2V4a1 1 0 011-1h5v2zM21.5 3a1 1 0 011 1v5h-2V5h-4V3h5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};